import { useRBAC } from './useRBAC';

/**
 * Hook to check if there's an active appraisal cycle
 * @returns boolean indicating if there's an active cycle
 */
export const useActiveCycle = (): boolean => {
  const { appraisalCycle } = useRBAC();
  
  // Check if cycle exists, is not an empty object, and status is 'active'
  // When API returns 404, appraisalCycle will be null or an empty object {}
  if (!appraisalCycle) {
    return false;
  }
  
  // Check if appraisalCycle is an empty object (when data: {} is returned)
  if (Object.keys(appraisalCycle).length === 0) {
    return false;
  }
  
  // Check if status exists and is 'active'
  return appraisalCycle.status === 'active';
};
